import { render, staticRenderFns } from "./BlockResult.vue?vue&type=template&id=abfc9758&scoped=true&"
import script from "./BlockResult.vue?vue&type=script&lang=js&"
export * from "./BlockResult.vue?vue&type=script&lang=js&"
import style0 from "./BlockResult.vue?vue&type=style&index=0&id=abfc9758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc9758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VLayout,VSpacer})
